<template>
    <div>
        slide
    </div>
</template>

<script>
import ctrl from "./list.js";
export default ctrl;
</script>